<template>
  <div class="meiyu">
    <div class="top">
      <div class="topdate">{{date}}</div>
      <span class="title">{{topTitle}}专题图</span>
      <div class="full"
           @click="buttonfull">
        <svg v-if="watchfull"
             class="icon"
             aria-hidden="true"
             style="color: #00dcfc;">
          <use xlink:href="#iconsuoxiaoquanping"></use>
        </svg>
        <svg v-else
             class="icon"
             aria-hidden="true"
             style="color: #00dcfc;">
          <use xlink:href="#iconquanping"></use>
        </svg>
      </div>
      <div class="back"
           @click="back">
        <img src="@/assets/meiyu/back.png"
             alt="">
        <span class="backdesc">返回</span>
      </div>
    </div>
    <div class="left_legend_btn" @mouseenter="show = true"></div>
    <transition name="el-zoom-in-top">
      <div v-show="show" class="left_legend" @mouseleave="show = false">
        <div class="legend_title">图层控制</div>
        <div class="item_content">
          <div class="item_legend">
            <span class="legend_name">水库</span>
            <el-switch
              v-model="skValue"
              @change="switchHandle"
              active-text="显示"
              inactive-text="隐藏">
            </el-switch>
          </div>
          <div class="item_legend">
            <span class="legend_name">山塘</span>
            <el-switch
              v-model="stValue"
              @change="switchHandle1"
              active-text="显示"
              inactive-text="隐藏">
            </el-switch>
          </div>
          <div class="item_legend">
            <span class="legend_name">水闸</span>
            <el-switch
              v-model="szValue"
              @change="switchHandle2"
              active-text="显示"
              inactive-text="隐藏">
            </el-switch>
          </div>
          <div class="item_legend">
            <span class="legend_name">水电站</span>
            <el-switch
              v-model="sdzValue"
              @change="switchHandle3"
              active-text="显示"
              inactive-text="隐藏">
            </el-switch>
          </div>
          <div class="item_legend">
            <span class="legend_name">雨量站</span>
            <el-switch
              v-model="ylzValue"
              @change="switchHandle4"
              active-text="显示"
              inactive-text="隐藏">
            </el-switch>
          </div>
          <div class="item_legend">
            <span class="legend_name">水位站</span>
            <el-switch
              v-model="swzValue"
              @change="switchHandle5"
              active-text="显示"
              inactive-text="隐藏">
            </el-switch>
          </div>
        </div>
      </div>
    </transition>
    <div class="selected_input">
      <el-select v-model="stationName" filterable  @change="selectChange" placeholder="请输入工程或者选择工程">
        <el-option
          v-for="item in allPointData"
          :key="item.onlyIdentification"
          :label="item.stName"
          :value="item.onlyIdentification">
        </el-option>
      </el-select>
    </div>
    <div
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      id="centermap"
      class="homepage-map"></div>
  </div>
</template>
<script>
import * as L from 'leaflet'
import screenfull from 'screenfull'
import meiyuTypes from '@/store/types/meiyu'
import comprehensiveMapTypes from '@/store/types/comprehensiveMap'
import request from '@/utils/request'
require('@/extend/leaflet-extend.js')
require('@/assets/map/leaflet.ChineseTmsProviders.js')
export default {
  name: 'meiyu',
  components: {},
  data () {
    return {
      skValue: true,
      stValue: false,
      szValue: true,
      sdzValue: false,
      ylzValue: true,
      swzValue: true,
      skStatus: false,
      stStatus: false,
      szStatus: false,
      sdzStatus: false,
      ylzStatus: false,
      swzStatus: false,
      show: false,
      topTitle: '',
      watchfull: '',
      isFullscreen: false,
      stationName: '',
      date: '',
      options: {},
      loading: true,
      map: '',
      stName: '',
      stType: '',
      riverName: '',
      allPointData: [],
      tempAllPoint: [],
      tempAllPointData: [],
      allSkMarkers: [],
      allStMarkers: [],
      allSzMarkers: [],
      allSdzMarkers: [],
      allYlzMarkers: [],
      allSwzMarkers: [],
      otherMarkers: [],
      allMarkers: [],
      skPointArr: [],
      stPointArr: [],
      szPointArr: [],
      sdzPointArr: [],
      ylzPointArr: [],
      swzPointArr: [],
      typeArr: []
    }
  },
  watch: {
    allPointData (newValue, oldValue) {
      let _this = this
      if ((newValue.length !== oldValue.length)) {
        _this.allPointData = Object.assign([], newValue)
        let aaa = []
        _this.allPointData.forEach(el => {
          aaa.push(el.stType)
        })
      }
    }
  },
  methods: {
    selecterLinkClick (item, index) {
      this.selecterLink = index
    },
    buttonfull () {
      if (!screenfull.enabled) {
        return false
      } else {
        screenfull.toggle()
      }
    },
    back () {
      this.isFullscreen = true
      this.$nextTick(() => { this.$router.go(-1) })
    },
    getnowtime () {
      let thedate = new Date()
      let year = thedate.getFullYear()
      let month = thedate.getMonth() + 1
      let date = thedate.getDate()
      let hours = thedate.getHours()
      let minutes = thedate.getMinutes()
      let seconds = thedate.getSeconds()
      let weekend = thedate.getDay()
      switch (weekend) {
        case 1:
          weekend = '星期一'
          break
        case 2:
          weekend = '星期二'
          break
        case 3:
          weekend = '星期三'
          break
        case 4:
          weekend = '星期四'
          break
        case 5:
          weekend = '星期五'
          break
        case 6:
          weekend = '星期六'
          break
        case 0:
          weekend = '星期日'
          break
      }
      this.date = year + '年' + this.conver(month) + '月' + this.conver(date) + '日' + ' ' + weekend + ' ' + this.conver(hours) + ':' + this.conver(minutes) + ':' + this.conver(seconds)
    },
    conver (s) {
      return s < 10 ? '0' + s : s
    },
    leaflet (arr) {
      let map = ''
      map = L.CreateTianDiTuMap('centermap', {
        crs: L.CRS.EPSG4490, zoomControl: false }).setView([30.17, 119.4], 11)
      L.tileLayer.CustomArcGISServerLayer(
        { minZoom: 8, // 最小缩放等级
          maxZoom: 21 // 最大缩放等级
        }).addTo(map)
      // GeoJson数据
      switch (this.topTitle) {
        case '黄泽江流域':
          this.drawBasinJson('hzj')
          map.setView([29.5, 121.02], 12)
          break
        case '长乐江流域':
          this.drawBasinJson('clj')
          map.setView([29.48, 120.65], 11)
          break
        case '澄潭江流域':
          this.drawBasinJson('ctj')
          map.setView([29.33, 120.75], 11)
          break
        case '新昌江流域':
          this.drawBasinJson('xcj')
          map.setView([29.39, 120.99], 12)
          break
        default:
          break
      }
      this.map = map
    },
    drawBasinJson (name) {
      var myStyle = {
        'color': '#2dd9f8',
        'weight': 3,
        'opacity': 1
      }
      request.get('http://' + window.location.host + '/yjjson/basinJson/' + name + '.json').then(res => {
        L.geoJSON(res.data, {
          style: myStyle
        }).addTo(this.map)
        // this.drawBoundary(res.data.features[0].geometry.coordinates, this.map)
      })
    },
    drawBoundary (blist, map) {
      // 画遮蔽层的相关方法
      // 思路: 首先在中国地图最外画一圈，圈住理论上所有的中国领土，然后再将每个闭合区域合并进来，并全部连到西北角。
      // 这样就做出了一个经过多次西北角的闭合多边形
      // 定义中国东南西北端点，作为第一层
      var pNW = { lat: 59.0, lng: 73.0 }
      var pNE = { lat: 59.0, lng: 136.0 }
      var pSE = { lat: 3.0, lng: 136.0 }
      var pSW = { lat: 3.0, lng: 73.0 }
      // 向数组中添加一次闭合多边形，并将西北角再加一次作为之后画闭合区域的起点
      var pArray = []
      pArray.push(pNW)
      pArray.push(pSW)
      pArray.push(pSE)
      pArray.push(pNE)
      pArray.push(pNW)
      // 循环添加各闭合区域
      for (var i = 0; i < blist.length; i++) {
        var points = []
        blist[i].forEach(item => {
          points.push({ lat: item[1], lng: item[0] })
        })
        // $.each(blist[i],function(k,v){
        //     points.push({lat:v[1],lng:v[0]})
        // })
        // 将闭合区域加到遮蔽层上，每次添加完后要再加一次西北角作为下次添加的起点和最后一次的终点
        pArray = pArray.concat(points)
        pArray.push(pArray[0])
      }
      // 添加遮蔽层
      var plyall = L.polygon(pArray, { color: 'transparent', fillColor: '#242422', fillOpacity: 0.8 }) // 建立多边形覆盖物
      plyall.addTo(map)
    },
    // 选中某个站点
    selectChange (val) {
      let nowAllPoint = this.allPointData
      nowAllPoint.forEach(item => {
        if (item.onlyIdentification === val) {
          this.map.flyTo([item.lat, item.lng], 18, {
            animate: true,
            duration: 1
          })
        }
      })
    },
    // 删除下拉菜单选项
    delSelectData (arr, attr, value) {
      let _this = this
      let index = 0
      for (let i in arr) {
        let tempStr = arr[i][attr]
        if (value !== 'other') {
          if (tempStr === value) {
            index = i
            arr.splice(index, 1)
          }
        } else {
          if (tempStr !== 'sk' && tempStr !== 'st' && tempStr !== 'sz' && tempStr !== 'sdz' && tempStr !== 'PP') {
            index = i
            arr.splice(index, 1)
          }
        }
      }
      _this.allPointData = arr
      console.log(_this.allPointData, 'delete.allPointData')
    },
    // 增加下拉菜单选项
    addSelectData (arr) {
      let _this = this
      arr.forEach(el => {
        _this.allPointData.push(el)
      })
      // console.log(_this.allPointData, 'add.allPointData')
    },
    // 获取地图所有点数据
    getAllData () {
      let _this = this
      this.loading = true
      switch (this.getTopTitle) {
        case '黄泽江流域':
          this.riverName = '黄泽江'
          break
        case '长乐江流域':
          this.riverName = '长乐江'
          break
        case '澄潭江流域':
          this.riverName = '澄潭江'
          break
        case '新昌江流域':
          this.riverName = '新昌江'
          break
        default:
          this.riverName = this.getTopTitle
          break
      }
      let aaa = []
      this.$store.dispatch(meiyuTypes.GET_VARIED_STATIONS, {
        stName: this.stationName,
        stType: this.stType,
        riverName: this.riverName
      }).then(data => {
        _this.allPointData = data.results
        _this.tempAllPointData = data.results
        if (_this.allPointData) {
          _this.allPointData.forEach(el => {
            if (el.stType === 'sk') {
              _this.skPointArr.push(el)
            } else if (el.stType === 'st') {
              _this.stPointArr.push(el)
            } else if (el.stType === 'sz') {
              _this.szPointArr.push(el)
            } else if (el.stType === 'sdz') {
              _this.sdzPointArr.push(el)
            } else if (el.stType === 'PP') {
              _this.ylzPointArr.push(el)
            } else if (el.stType !== 'sk' && el.stType !== 'st' && el.stType !== 'sz' && el.stType !== 'sdz' && el.stType !== 'PP') {
              _this.swzPointArr.push(el)
            }
            aaa.push(el.stType)
          })
          _this.drawPoint(_this.allPointData)
          // 默认不显示山塘和水电站标记
          this.allStMarkers.forEach(element => {
            _this.map.removeLayer(element)
          })
          this.allSdzMarkers.forEach(element => {
            _this.map.removeLayer(element)
          })
          // this.delSelectData(this.allPointData, 'stType', 'st')
          // this.delSelectData(this.allPointData, 'stType', 'sdz')
        }
        console.log(aaa)
        _this.loading = false
      }).catch(err => console.log(err))
    },
    // 添加点
    drawPoint (arr) {
      let map = this.map
      let _this = this
      console.log(arr)
      if (arr) {
        arr.forEach(item => {
          let skIcon = L.icon({
            iconUrl: require('@/assets/map/images/sk.png'),
            iconAnchor: [8, 8]
          })
          let sdzIcon = L.icon({
            iconUrl: require('@/assets/map/images/sdz.png'),
            iconAnchor: [8, 8]
          })
          let stIcon = L.icon({
            iconUrl: require('@/assets/map/images/st.png'),
            iconAnchor: [8, 8]
          })
          let szIcon = L.icon({
            iconUrl: require('@/assets/map/images/sz.png'),
            iconAnchor: [8, 8]
          })
          let ylzIcon = L.icon({
            iconUrl: require('@/assets/map/images/ylz.png'),
            iconAnchor: [8, 8]
          })
          let swzIcon = L.icon({
            iconUrl: require('@/assets/map/images/swz.png'),
            iconAnchor: [8, 8]
          })
          let myIcon = skIcon
          if (item.stType === 'sk') {
            myIcon = skIcon
          } else if (item.stType === 'st') {
            myIcon = stIcon
          } else if (item.stType === 'sz') {
            myIcon = szIcon
          } else if (item.stType === 'sdz') {
            myIcon = sdzIcon
          } else if (item.stType === 'PP') {
            myIcon = ylzIcon
          } else if (item.stType === 'ZZ' || item.stType === 'RR' || item.stType === 'RR,PP' || item.stType === 'ZZ,PP') {
            myIcon = swzIcon
          }
          let markers = L.marker([item.lat, item.lng], { icon: myIcon, title: item.adcdName }).addTo(map)
          if (item.stType !== 'ZZ' && item.stType !== 'RR' && item.stType !== 'RR,PP' && item.stType !== 'ZZ,PP' && item.stType !== 'PP') {
            let itemId = item.onlyIdentification.split('@')[0]
            let itemType = item.onlyIdentification.split('@')[1]
            let engineeringType = ''
            if (item.stType === 'sk' || item.stType === 'sdz') {
              engineeringType = itemType + '_la'
            } else {
              engineeringType = item.stType
            }
            _this.$store.dispatch(comprehensiveMapTypes.GET_ITEM_DATA, {
              id: itemId,
              engineeringType: engineeringType
            }).then(data => {
              console.log(data, 'data')
              if (itemType === 'sk') {
                markers.bindPopup(
                  '<div class="villageName">' + item.stName + '</div>' +
                    '<div id="tab">' +
                      '<ul class="list">' +
                        '<li class="list_nav active" id="list_first">基本信息</li>' +
                      '</ul>' +
                      '<ul class="tab">' +
                        '<li class="tab_nav on">' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>水库类型:</span></div>' +
                            '<div class="contentnum"><span>' + (data.typeName === undefined ? '-' : data.typeName) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>所在位置:</span></div>' +
                            '<div class="contentnum"><span>' + (data.town === undefined ? '-' : data.town) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>总库容:</span></div>' +
                            '<div class="contentnum"><span>' + (data.totalVolume === undefined ? '-' : data.totalVolume) + '</span><span style="color:#000000"> 万m³</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>集雨面积:</span></div>' +
                            '<div class="contentnum"><span>' + (data.rainfallCollectionArea === undefined ? '-' : data.rainfallCollectionArea) + '</span><span style="color:#000000"> km²</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>设计洪水位:</span></div>' +
                            '<div class="contentnum"><span>' + (data.designFloodLevel === undefined ? '-' : data.designFloodLevel) + '</span><span style="color:#000000"> m</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>坝址多年平均径流量:</span></div>' +
                            '<div class="contentnum"><span>' + (data.averageFlow === undefined ? '-' : data.averageFlow) + '</span><span style="color:#000000"> 万m³</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>主坝坝高:</span></div>' +
                            '<div class="contentnum"><span>' + (data.tributaryName === undefined ? '-' : data.tributaryName) + '</span><span style="color:#000000"> m</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>主坝坝长:</span></div>' +
                            '<div class="contentnum"><span>' + (data.damLength === undefined ? '-' : data.damLength) + '</span><span style="color:#000000"> m</span></div>' +
                          '</div>' +
                        '</li>' +
                      '</ul>' +
                    '</div>'
                ).bindTooltip('<b>' + item.stName + '</b>')
              } else if (itemType === 'sz') {
                markers.bindPopup(
                  '<div class="villageName">' + item.stName + '</div>' +
                    '<div id="tab">' +
                      '<ul class="list">' +
                        '<li class="list_nav active" id="list_first">基本信息</li>' +
                      '</ul>' +
                      '<ul class="tab">' +
                        '<li class="tab_nav on">' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>水闸类型:</span></div>' +
                            '<div class="contentnum"><span>' + (data.gateType === undefined ? '-' : data.gateType) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>所在位置:</span></div>' +
                            '<div class="contentnum"><span>' + (data.town === undefined ? '-' : data.town) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>工程等级:</span></div>' +
                            '<div class="contentnum"><span>' + (data.projectLevel === undefined ? '-' : data.projectLevel) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>建筑物级别:</span></div>' +
                            '<div class="contentnum"><span>' + (data.mainBuildingLevle === undefined ? '-' : data.mainBuildingLevle) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>建设状态:</span></div>' +
                            '<div class="contentnum"><span>' + (data.buildState === undefined ? '-' : data.buildState) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>建成时间:</span></div>' +
                            '<div class="contentnum"><span>' + (data.buildYear === undefined || data.buildMonth === undefined ? '-' : data.buildYear + '-' + data.buildMonth) + '</span></div>' +
                          '</div>' +
                        '</li>' +
                      '</ul>' +
                    '</div>'
                ).bindTooltip('<b>' + item.stName + '</b>')
              } else if (itemType === 'st') {
                markers.bindPopup(
                  '<div class="villageName">' + item.stName + '</div>' +
                    '<div id="tab">' +
                      '<ul class="list">' +
                        '<li class="list_nav active" id="list_first">基本信息</li>' +
                      '</ul>' +
                      '<ul class="tab">' +
                        '<li class="tab_nav on">' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>所在位置:</span></div>' +
                            '<div class="contentnum"><span>' + (data.town === undefined ? '-' : data.town) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>主要功能:</span></div>' +
                            '<div class="contentnum"><span>' + (data.zygn === undefined ? '-' : data.zygn) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>集雨面积:</span></div>' +
                            '<div class="contentnum"><span>' + (data.jymj === undefined ? '-' : data.jymj) + '</span><span style="color:#000000"> km²</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>最大坝高:</span></div>' +
                            '<div class="contentnum"><span>' + (data.zdbg === undefined ? '-' : data.zdbg) + '</span><span style="color:#000000"> m</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>坝顶长度:</span></div>' +
                            '<div class="contentnum"><span>' + (data.bdcd === undefined ? '-' : data.bdcd) + '</span><span style="color:#000000"> m</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>坝顶宽度:</span></div>' +
                            '<div class="contentnum"><span>' + (data.bdkd === undefined ? '-' : data.bdkd) + '</span><span style="color:#000000"> m</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>巡查员姓名:</span></div>' +
                            '<div class="contentnum"><span>' + (data.xcyxm === undefined ? '-' : data.xcyxm) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>巡查员电话:</span></div>' +
                            '<div class="contentnum"><span>' + (data.xcydh === undefined ? '-' : data.xcydh) + '</span></div>' +
                          '</div>' +
                        '</li>' +
                      '</ul>' +
                    '</div>'
                ).bindTooltip('<b>' + item.stName + '</b>')
              } else if (itemType === 'sdz') {
                markers.bindPopup(
                  '<div class="villageName">' + item.stName + '</div>' +
                    '<div id="tab">' +
                      '<ul class="list">' +
                        '<li class="list_nav active" id="list_first">基本信息</li>' +
                      '</ul>' +
                      '<ul class="tab">' +
                        '<li class="tab_nav on">' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>所在位置:</span></div>' +
                            '<div class="contentnum"><span>' + (data.town === undefined ? '-' : data.town) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>所在流域:</span></div>' +
                            '<div class="contentnum"><span>' + (data.xmszly === undefined ? '-' : data.xmszly) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>建设（运营）状态:</span></div>' +
                            '<div class="contentnum"><span>' + (data.jsdw === undefined ? '-' : data.jsdw) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>设计年发电量:</span></div>' +
                            '<div class="contentnum"><span>' + (data.sjnfdl === undefined ? '-' : data.sjnfdl) + '</span><span style="color:#000000"> 万KW·h</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>装机容量:</span></div>' +
                            '<div class="contentnum"><span>' + (data.zjrl === undefined ? '-' : data.zjrl) + '</span><span style="color:#000000"> KW</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>电站联系人:</span></div>' +
                            '<div class="contentnum"><span>' + (data.dzlxr === undefined ? '-' : data.dzlxr) + '</span></div>' +
                          '</div>' +
                          '<div class="tabcontnet">' +
                            '<div class="contentname"><span>联系人电话:</span></div>' +
                            '<div class="contentnum"><span>' + (data.lxrxm === undefined ? '-' : data.lxrxm) + '</span></div>' +
                          '</div>' +
                        '</li>' +
                      '</ul>' +
                    '</div>'
                ).bindTooltip('<b>' + item.stName + '</b>')
              }
            }).catch(() => {})
          } else {
            markers.bindPopup('<b style="display:block;text-align:center">暂无信息</b>').bindTooltip('<b>' + item.stName + '</b>').addTo(map)
          }
          if (item.stType === 'sk') {
            _this.allSkMarkers.push(markers)
          } else if (item.stType === 'st') {
            _this.allStMarkers.push(markers)
          } else if (item.stType === 'sz') {
            _this.allSzMarkers.push(markers)
          } else if (item.stType === 'sdz') {
            _this.allSdzMarkers.push(markers)
          } else if (item.stType === 'PP') {
            _this.allYlzMarkers.push(markers)
          } else if (item.stType === 'ZZ' || item.stType === 'RR' || item.stType === 'RR,PP' || item.stType === 'ZZ,PP') {
            _this.allSwzMarkers.push(markers)
          } else {
            _this.allMarkers.push(markers)
          }
        })
      }
    },
    // 图层控制switch开关
    // 1.水库
    switchHandle (val) {
      let _this = this
      this.skStatus = val
      if (val === true) {
        this.drawPoint(this.skPointArr)
        // this.addSelectData(this.skPointArr)
      } else {
        // this.delSelectData(this.allPointData, 'stType', 'sk')
        // 清空该类型标记点
        this.allSkMarkers.forEach(element => {
          _this.map.removeLayer(element)
        })
        this.allSkMarkers = []
      }
    },
    // 2.山塘
    switchHandle1 (val) {
      let _this = this
      this.sdStatus = val
      if (val === true) {
        this.stType = 'st'
        this.drawPoint(this.stPointArr)
        // this.addSelectData(this.stPointArr)
      } else {
        // this.delSelectData(this.allPointData, 'stType', 'st')
        // 清空该类型标记点
        this.allStMarkers.forEach(element => {
          _this.map.removeLayer(element)
        })
        this.allStMarkers = []
      }
    },
    // 3.水闸
    switchHandle2 (val) {
      let _this = this
      this.szStatus = val
      if (val === true) {
        this.drawPoint(this.szPointArr)
        // this.addSelectData(this.szPointArr)
      } else {
        // this.delSelectData(this.allPointData, 'stType', 'sz')
        // 清空该类型标记点
        this.allSzMarkers.forEach(element => {
          _this.map.removeLayer(element)
        })
        this.allSzMarkers = []
      }
    },
    // 4.水电站
    switchHandle3 (val) {
      let _this = this
      this.sdzStatus = val
      if (val === true) {
        this.drawPoint(this.sdzPointArr)
        // this.addSelectData(this.sdzPointArr)
      } else {
        // this.delSelectData(this.allPointData, 'stType', 'sdz')
        // 清空该类型标记点
        this.allSdzMarkers.forEach(element => {
          _this.map.removeLayer(element)
        })
        this.allSdzMarkers = []
      }
    },
    // 5.雨量站
    switchHandle4 (val) {
      let _this = this
      this.ylzStatus = val
      if (val === true) {
        this.drawPoint(this.ylzPointArr)
        // this.addSelectData(this.ylzPointArr)
      } else {
        // this.delSelectData(this.allPointData, 'stType', 'PP')
        // 清空该类型标记点
        this.allYlzMarkers.forEach(element => {
          _this.map.removeLayer(element)
        })
        this.allYlzMarkers = []
      }
    },
    // 6.水位站
    switchHandle5 (val) {
      let _this = this
      this.swzStatus = val
      if (val === true) {
        this.drawPoint(this.swzPointArr)
        // this.addSelectData(this.swzPointArr)
      } else {
        // this.delSelectData(this.allPointData, 'stType', 'other')
        // 清空该类型标记点
        this.allSwzMarkers.forEach(element => {
          _this.map.removeLayer(element)
        })
        this.allSwzMarkers = []
      }
    }
  },
  computed: {
    getTopTitle () {
      return this.$store.state.topTitleName
    }
  },
  mounted () {
    // 获取路由跳转标记，标记当前跳转的是哪个页面
    this.topTitle = this.getTopTitle
    window.onresize = () => {
      this.watchfull = screenfull.isFullscreen
    }
    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.getnowtime()
    }, 1000)
    this.$nextTick(() => {
      this.leaflet()
      this.getAllData()
    })
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style>
.select-option {
  z-index: 9999 !important;
  border: 1px solid #00f0ff;
  background-color: #060a22;
}
.select-option .el-select-dropdown__item {
  background-color: #060a22;
  color: #ffffff;
}
.select-option .el-select-dropdown__item.hover,
.select-option .el-select-dropdown__item:hover {
  background-color: #10173e;
}
</style>
<style lang="less" scoped>
@import url("~@/assets/map/leaflet.css");
.centerMapContent {
  width: 100%;
  height: 1080px;
  position: relative;
}
#centermap {
  width: 100%;
  height: 1080px;
  position: relative;
}
@media screen and (min-height: 1100px) {
  .centerMapContent {
    width: 100%;
    height: 100%;
    position: relative;
  }
  #centermap {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.mapboxgl-control-container {
  display: none;
}
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  /* background:rgba(162,44,25,.6); */
  background-image: url(~@/assets/meiyu/chaojin.png);
  background-repeat: no-repeat;
  background-size: 141px 87px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  /* min-height: 36px; */
  height: 87px;
  /* height: 100%; */
}
#chartall,
#danzhan,
#zhazhan {
  z-index: 9999999 !important;
}
#rainchartAll {
  width: 1000px;
  height: 280px;
  margin: 50px auto 0 auto;
}
.row-bg {
  padding: 10px 0;
  position: absolute;
  width: 850px;
  height: 85px;
  left: 50%;
  margin-left: -425px;
  top: 85px;
  z-index: 9999;
}
.warn-name {
  width: 100%;
  height: 20px;
  font-size: 16px;
  text-align: center;
  color: #fff;
  margin: 0;
  padding: 15px 0;
}
.warn-num {
  width: 100%;
  height: 20px;
  text-align: center;
  color: #ffff00;
  font-size: 30px;
  margin: 0;
  padding: 5px 0;
  font-style: italic;
  font-weight: 900;
}
.warn-num > span {
  font-size: 16px;
  color: #fff;
  margin-left: 10px;
}
.row-legend {
  width: 185px;
  height: 230px;
  position: absolute;
  bottom: 0;
  top: 745px;
  left: 1237px;
  z-index: 9999;
}
.legend {
  height: 230px;
  background: none;
  background-image: url(~@/assets/homepage_img/legendbody.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.legend-closed {
  width: 10px;
  height: 10px;
  padding: 0;
  line-height: 12px;
  position: absolute;
  color: #fff;
  top: 13px;
  right: 22px;
  cursor: pointer;
}
.show-legend {
  width: 150px;
  height: 35px;
  position: absolute;
  top: 721px;
  right: 525px;
  line-height: 40px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  cursor: pointer;
  z-index: 9999;
  color: #fff;
  font-size: 16px;
  text-align: center;
  background-image: url(~@/assets/homepage_img/legendtitle.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.el-icon-arrow-up {
  transform: rotateZ(0deg);
  margin-left: 110px;
}
.el-icon-arrow-up-rotatez {
  transform: rotateZ(180deg);
  animation: slowClose 0.2s ease;
}
@keyframes slowClose {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(180deg);
  }
}
</style>
<style lang="less" scoped>
// 地图内标记点的点击事件弹窗样式
.meiyu #centermap /deep/ .leaflet-popup-pane .leaflet-zoom-animated{
  width:600px;
  .leaflet-popup-content{
    width: 565px !important;
    .villageName {
      font-size: 18px;
      color: #303133;
    }
    #tab{
      position: relative;
      width: 100%;
      height: 200px;
      margin: 10px auto;
      .list {
        width: 100%;
        height: 25px;
        padding: 0;
        margin: 2px auto;
        border-bottom: 1px solid #ccc;
      }
      li {
        list-style: none;
      }
      .list_nav {
        float: left;
        width: 90px;
        height: 25px;
        font-size: 15px;
        text-align: center;
        line-height: 25px;
        cursor: pointer;
      }
      .active {
        color: #409EFF;
        border-bottom: 1px solid #409EFF;
      }
      .tab_nav {
        display: none;
        position: absolute;
        top:25px;
        width: 100%;
        max-height: 320px;
        overflow: auto;
      }
      .on {
        display: block;
      }
      .tab {
        width:100%;
        height:80%;
        padding: 0;
        margin: 0 auto;
        .tabcontnet {
          font-size: 15px;
          width: 50%;
          margin-top: 10px;
          float: left;
          .contentname {
            margin-right: 0.15625rem;
            width: 60%;
            float: left;
            color: #999999;
          }
           .contentnum {
            width: 35%;
            float: left;
            color: rgb(238, 121, 12);
          }
        }
      }
    }
  }
}
.meiyu {
  // background: #21251f;
  height: 100%;
  position: relative;
  .left_legend_btn {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 105px;
    right: 360px;
    z-index: 999;
    border: 2px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
    background: #fff url('~@/assets/comprehensive/switch.png');
    background-repeat: no-repeat;
    background-size: 65% 55%;
    background-position: center;
  }
  .left_legend{
    width: 270px;
    height: 300px;
    position: absolute;
    top: 105px;
    right: 360px;
    z-index: 999;
    background: #ffffff;
    border-radius: 5px;
    .legend_title{
      width: 95%;
      height: 40px;
      line-height: 40px;
      margin: 5px 5px 0;
      padding: 2px 10px;
      font-size: 18px;
      background: #F5F5F5
    }
    .item_content {
      .item_legend {
        width: 95%;
        height: 100%;
        line-height: 35px;
        margin: 0 5px;
        padding: 2px 10px;
        font-size: 14px;
        border: 1px solid #ccc;
        span{
          display: block;
          float: left;
          &:nth-of-type(1) {
            width: 40%;
            font-size: 14px;
            height: 100%;
          }
        }
        /deep/ .el-switch{
          width: 60%;
          height: 100%;
          .el-switch__core{
            width: 40px !important;
          }
          .el-switch__label.el-switch__label--left, .el-switch__label.el-switch__label--right {
            span{
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .el-dialog {
    .topthree {
      width: 100%;
      height: 70px;
      .topitem {
        position: relative;
        color: #fff;
        width: 117px;
        margin-left: 45px;
        margin-top: 25px;
        .topdesc {
          font-size: 14px;
          position: absolute;
          top: 11px;
          left: 25px;
          width: 100px;
          left: 50%;
          margin-left: -50px;
          height: 15px;
          text-align: center;
        }
        .val {
          .topdesc;
          top: 35px;
          left: 45px;
          font-size: 24px;
          text-align: center;
          font-style: italic;
          font-weight: 500;
          .danwei {
            font-size: 14px;
            position: absolute;
            top: 10px;
          }
        }
      }
    }
    .title {
      height: 33px;
      position: relative;
      margin-top: -8px;
      .titlename {
        height: 33px;
        position: relative;
        /deep/ .titlename_select {
          position: absolute;
          top: -13px;
          .el-input--suffix {
            .el-input__inner {
              width: 160px;
              background: #060a22;
              border: none;
              color: #ffffff;
              font-size: 18px;
            }
          }
        }
        .button {
          position: relative;
          display: inline-block;
          padding: 0.5rem 1rem;
          background: transparent;
          color: white;
          text-transform: uppercase;
          text-decoration: none;
          font: bold 200%/1 sans-serif;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 0;
            background: #fff;
            transform: skew(45deg);
          }
        }
        .titlename_span {
          font-size: 18px;
          color: #fff;
          position: absolute;
          top: 0;
        }
        .titlename_up {
          width: 100%;
          height: 100%;
          span.ssyq,
          span.sssq {
            width: 20%;
            font-size: 18px;
            display: block;
            float: left;
            color: #fff;
          }
          .selected_time {
            width: 80%;
            height: 100%;
            float: right;
            .time_item {
              cursor: pointer;
              height: 30px;
              float: right;
              padding: 0 7px;
              line-height: 26px;
              display: block;
              font-size: 14px;
              color: #ffffff;
              border: 1px solid #079eb6;
              transform: skewX(-30deg);
              span {
                display: block;
                transform: skewX(30deg);
              }
            }
            .item_active {
              background: #064961;
            }
          }
        }
        img {
          width: 100%;
          height: 7px;
          position: absolute;
          top: 27px;
        }
      }
    }
  }
  .top {
    background-image: url("~@/assets/meiyu/top.png");
    background-repeat: no-repeat;
    background-size: 100% 200%;
    height: 77px;
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 99999;
    .topdate {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      left: 65px;
    }
    .title {
      margin-top: 23px;
      font-size: 32px;
      color: #00f0ff;
      font-weight: bold;
      display: inline-block;
    }
    .person {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      right: 90px;
      .dbld {
        span {
          color: #fec307;
        }
      }
      .zbry {
        .dbld;
        margin-left: 30px;
      }
    }
    .back {
      position: absolute;
      cursor: pointer;
      right: 15px;
      top: 8px;
      width: 70px;
      img {
        width: 26px;
        height: 24px;
      }
      .backdesc {
        color: #00dcfc;
        font-size: 15px;
        line-height: 15px;
        display: inline-block;
        vertical-align: middle;
        margin-top: -8px;
        margin-left: 5px;
      }
    }
    .full {
      .back;
      right: 75px;
    }
  }
  .selected_input {
    width: 300px;
    height: 45px;
    position: absolute;
    top: 100px;
    right: 50px;
    z-index: 999;
    .select_title{
      height: 100%;
      line-height: 45px;
      float: left;
      font-size: 16px;
      color: #ffffff;
    }
    .el-select{
      margin-left: 10px;
    }
  }
  .left {
    width: 430px;
    height: 850px;
    position: absolute;
    // background: #fec307;
    top: 75px;
    bottom: 40px;
    left: 50px;
    z-index: 9999;
    .warning {
      width: 430px;
      height: 85px;
      line-height: 85px;
      text-align: center;
      background-image: url("~@/assets/meiyu/warningbox.png");
      background-repeat: no-repeat;
      background-size: 110% 200%;
      background-position: -14px -43px;
      img {
        margin-left: 30px;
        width: 147px;
        height: 23px;
      }
      span {
        margin-left: 20px;
        font-size: 18px;
        color: #fff;
        // margin-top: -5px;
        float: right;
        margin-right: 55px;
      }
    }
    .realtimerain {
      width: 100%;
      height: 960px;
      margin-top: 10px;
      background: #060a22;
      // box-shadow: 0 0 5px #283955 inset;
      box-shadow: 0 0 12px #253578;
      padding: 15px 27px;
      .contain {
        width: 380px;
        height: 100%;
        // background: #fec307;
        .title {
          height: 33px;
          .titlename {
            height: 33px;
            position: relative;
            /deep/ .titlename_select {
              position: absolute;
              top: -13px;
              .el-input--suffix {
                .el-input__inner {
                  width: 160px;
                  background: #060a22;
                  border: none;
                  color: #ffffff;
                  font-size: 18px;
                }
              }
            }
            .button {
              position: relative;
              display: inline-block;
              padding: 0.5rem 1rem;
              background: transparent;
              color: white;
              text-transform: uppercase;
              text-decoration: none;
              font: bold 200%/1 sans-serif;
              &::before {
                content: "";
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 0;
                background: #fff;
                transform: skew(45deg);
              }
            }
            .titlename_span {
              font-size: 18px;
              color: #fff;
              position: absolute;
              top: 0;
            }
            .titlename_up {
              width: 100%;
              height: 100%;
              span.ssyq,
              span.sssq {
                width: 20%;
                font-size: 18px;
                display: block;
                float: left;
                color: #fff;
              }
              .selected_time {
                width: 80%;
                height: 100%;
                float: right;
                .time_item {
                  cursor: pointer;
                  height: 30px;
                  float: right;
                  padding: 0 7px;
                  line-height: 26px;
                  display: block;
                  font-size: 14px;
                  color: #ffffff;
                  border: 1px solid #079eb6;
                  transform: skewX(-30deg);
                  span {
                    display: block;
                    transform: skewX(30deg);
                  }
                }
                .item_active {
                  background: #064961;
                }
              }
            }
            img {
              width: 380px;
              height: 7px;
              position: absolute;
              top: 27px;
            }
          }
        }
        .qlymyl{
          margin-top: 20px;
          position: relative;
          .descword{
            color: #fff;
            position: absolute;
            font-size: 18px;
            line-height: 22px;
            left:50%;
            margin-left: -90px;
            margin-top: 15px;
            .num{
              color: #fec307;
              font-size: 28px;
              font-style: italic;
            }
            .danwei{
              font-size: 14px;
              font-style: italic;
            }
          }
          img{
            width: 384px;
            height: 55px;
          }
        }
        .barcharts {
          height: 216px;
          position: relative;
          margin-top: 20px;
          #rainchart {
            width: 380px;
            height: 216px;
          }
        }
        .area_rainfall {
          height: 130px;
          position: relative;
          color: #fff;
          .topthree {
            height: 70px;
            margin-top: 10px;
            justify-content: space-between;
            display: flex;
            .topitem {
              width: 30%;
              position: relative;
              background: url("~@/assets/meiyu/bluebox.png");
              background-repeat: no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              .topdesc {
                font-size: 14px;
                position: absolute;
                top: 11px;
                left: 25px;
                width: 90px;
                left: 50%;
                margin-left: -45px;
                height: 15px;
                text-align: center;
              }
              .val {
                .topdesc;
                top: 35px;
                left: 45px;
                font-size: 24px;
                text-align: center;
                font-style: italic;
                font-weight: 500;
                .danwei {
                  font-size: 14px;
                  position: absolute;
                  top: 10px;
                }
              }
            }
          }
          .detail {
            margin-top: 40px;
            height: 70px;
            width: 390px;
            background-image: url("~@/assets/meiyu/longbox.png");
            background-repeat: no-repeat;
            background-size: 98% 100%;
            display: inline-block;
            .itemdesc {
              margin-top: 10px;
              width: 130px;
              height: 70px;
              text-align: center;
              font-size: 14px;
              display: inline-block;
              .tit {
                display: block;
              }
              .val {
                font-size: 24px;
                color: #00deff;
                font-style: italic;
                font-weight: 500;
                display: inline-block;
                margin-top: 10px;
                img {
                  width: 14px;
                  height: 24px;
                }
                .danwei {
                  margin-left: -5px;
                }
              }
            }
          }
          .name {
            font-size: 13px;
            color: #fff;
            position: relative;
            font-weight: bold;
          }
        }
        .riverBasin_rainfall {
          height: 130px;
          position: relative;
          color: #fff;
          .topthree {
            height: 70px;
            margin-top: 10px;
            justify-content: space-between;
            display: flex;
            background: url("~@/assets/homepage_img/glymyl_bg.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center center;
            .topitem {
              width: 25%;
              position: relative;
              img {
                width: 117px;
                height: 71px;
              }
              .topdesc {
                font-size: 14px;
                position: absolute;
                top: 11px;
                left: 25px;
                width: 90px;
                left: 50%;
                margin-left: -45px;
                height: 15px;
                text-align: center;
              }
              .val {
                .topdesc;
                color: #00deff;
                top: 35px;
                left: 45px;
                font-size: 24px;
                text-align: center;
                font-style: italic;
                font-weight: 500;
                .danwei {
                  font-size: 14px;
                  position: absolute;
                  top: 10px;
                }
              }
            }
          }
          .detail {
            margin-top: 40px;
            height: 70px;
            width: 390px;
            background-image: url("~@/assets/meiyu/longbox.png");
            background-repeat: no-repeat;
            background-size: 98% 100%;
            display: inline-block;
            .itemdesc {
              margin-top: 10px;
              width: 130px;
              height: 70px;
              text-align: center;
              font-size: 14px;
              display: inline-block;
              .tit {
                display: block;
              }
              .val {
                font-size: 24px;
                color: #00deff;
                font-style: italic;
                font-weight: 500;
                display: inline-block;
                margin-top: 10px;
                img {
                  width: 14px;
                  height: 24px;
                }
                .danwei {
                  margin-left: -5px;
                }
              }
            }
          }
          .name {
            font-size: 13px;
            color: #fff;
            position: relative;
            font-weight: bold;
          }
        }
        .hydrologicalStation_rainfall {
          height: 130px;
          position: relative;
          color: #fff;
          .topthree {
            height: 70px;
            margin-top: 10px;
            justify-content: space-between;
            display: flex;
            .topitem {
              width: 49%;
              position: relative;
              background-repeat: no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              &:nth-of-type(1) {
                background: url("~@/assets/homepage_img/swzmyl_left_bg.png");
              }
              &:nth-of-type(2) {
                background: url("~@/assets/homepage_img/swzmyl_right_bg.png");
              }
              .topdesc {
                font-size: 14px;
                position: absolute;
                top: 11px;
                right: 25px;
                width: 90px;
                margin-left: -45px;
                height: 15px;
                text-align: center;
              }
              .val {
                .topdesc;
                top: 35px;
                right: 40px;
                font-size: 24px;
                text-align: center;
                font-style: italic;
                font-weight: 500;
                .danwei {
                  font-size: 14px;
                  position: absolute;
                  top: 10px;
                }
              }
            }
          }
          .detail {
            margin-top: 40px;
            height: 70px;
            width: 390px;
            background-image: url("~@/assets/meiyu/longbox.png");
            background-repeat: no-repeat;
            background-size: 98% 100%;
            display: inline-block;
            .itemdesc {
              margin-top: 10px;
              width: 130px;
              height: 70px;
              text-align: center;
              font-size: 14px;
              display: inline-block;
              .tit {
                display: block;
              }
              .val {
                font-size: 24px;
                color: #00deff;
                font-style: italic;
                font-weight: 500;
                display: inline-block;
                margin-top: 10px;
                img {
                  width: 14px;
                  height: 24px;
                }
                .danwei {
                  margin-left: -5px;
                }
              }
            }
          }
          .name {
            font-size: 13px;
            color: #fff;
            position: relative;
            font-weight: bold;
          }
        }
        .stationTop10_rainfall {
          height: 320px;
          position: relative;
          color: #fff;
          .topthree {
            height: 220px;
            margin-top: 25px;
            background: url("~@/assets/homepage_img/czTop10.png");
            background-repeat: no-repeat;
            background-position: center center;
            .topthree_left {
              .topitem {
                &:nth-of-type(1) .tag_num {
                  background: url("~@/assets/homepage_img/top10_1.png");
                }
                &:nth-of-type(2) .tag_num {
                  background: url("~@/assets/homepage_img/top10_2.png");
                }
                &:nth-of-type(3) .tag_num {
                  background: url("~@/assets/homepage_img/top10_3.png");
                }
                &:nth-of-type(4) .tag_num {
                  background: url("~@/assets/homepage_img/top10_4.png");
                }
                &:nth-of-type(5) .tag_num {
                  background: url("~@/assets/homepage_img/top10_5.png");
                }
              }
            }
            .topthree_right {
              padding-left: 5%;
              .topitem {
                &:nth-of-type(1) .tag_num {
                  background: url("~@/assets/homepage_img/top10_6.png");
                }
                &:nth-of-type(2) .tag_num {
                  background: url("~@/assets/homepage_img/top10_7.png");
                }
                &:nth-of-type(3) .tag_num {
                  background: url("~@/assets/homepage_img/top10_8.png");
                }
                &:nth-of-type(4) .tag_num {
                  background: url("~@/assets/homepage_img/top10_9.png");
                }
                &:nth-of-type(5) .tag_num {
                  background: url("~@/assets/homepage_img/top10_10.png");
                }
              }
            }
            .topthree_item {
              width: 50%;
              float: left;
              .topitem {
                width: 100%;
                height: 45px;
                line-height: 45px;
                float: left;
                position: relative;
                background-repeat: no-repeat;
                background-position: center center;
                span {
                  display: block;
                  float: left;
                }
                .tag_num {
                  width: 20px;
                  height: 20px;
                  margin-right: 5px;
                  margin-top: 12px;
                  background-repeat: no-repeat;
                  background-position: center center;
                }
                .topdesc {
                  font-size: 14px;
                  width: 90px;
                  height: 100%;
                  text-align: left;
                }
                .val {
                  .topdesc;
                  width: 50px;
                  text-align: right;
                }
              }
            }
          }
          .detail {
            margin-top: 40px;
            height: 70px;
            width: 390px;
            background-image: url("~@/assets/meiyu/longbox.png");
            background-repeat: no-repeat;
            background-size: 98% 100%;
            display: inline-block;
            .itemdesc {
              margin-top: 10px;
              width: 130px;
              height: 70px;
              text-align: center;
              font-size: 14px;
              display: inline-block;
              .tit {
                display: block;
              }
              .val {
                font-size: 24px;
                color: #00deff;
                font-style: italic;
                font-weight: 500;
                display: inline-block;
                margin-top: 10px;
                img {
                  width: 14px;
                  height: 24px;
                }
                .danwei {
                  margin-left: -5px;
                }
              }
            }
          }
          .name {
            font-size: 13px;
            color: #fff;
            position: relative;
            font-weight: bold;
          }
        }
      }
    }
    .realtimewater {
      .realtimerain;
      margin-top: 10px;
      height: 520px;
      padding: 15px 0;
      .contain {
        height: 290px;
        width: 405px;
        .title {
          margin-left: 27px;
        }
        .content {
          margin-top: 10px;
          width: 430px;
        }
      }
    }
  }
  .right {
    width: 430px;
    height: 800px;
    position: absolute;
    top: 75px;
    bottom: 40px;
    right: 50px;
    z-index: 9999;
    .sk {
      .left>.realtimerain;
      height: 420px;
      .echart_content {
        width: 380px;
        height: 280px;
        margin-top: 10px;
        padding-top: 30px;
        position: relative;
        overflow: hidden;
      }
      .echart_down {
        width: 380px;
        height: 70px;
        margin-top: 15px;
        padding: 10px;
        border-top: 1px solid #2dd9f8;
        .echart_down_img {
          width: 180px;
          height: 100%;
          float: left;
          background-image: url("~@/assets/meiyu/right_echart_down.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .echart_down_right {
          width: 180px;
          height: 100%;
          float: left;
          .down_right_title {
            width: 100%;
            height: 50%;
            font-size: 15px;
            color: #fff;
            line-height: 30px;
            text-align: center;
            display: block;
          }
          .down_right_num {
            width: 100%;
            height: 50%;
            font-size: 26px;
            line-height: 30px;
            text-align: center;
            color: #2dd9f8;
            display: block;
            b {
              font-style: italic;
            }
          }
        }
      }
    }
    .zz {
      .left>.realtimerain;
      height: 520px;
      .more {
        float: right;
        font-size: 15px;
        color: #00deff;
        cursor: pointer;
      }
      .content {
        .tag_item {
          display: block;
          float: left;
        }
        .tag_num {
          width: 75%;
        }
        .tag {
          width: 15%;
          height: 23px;
          margin-left: 4px;
          background-repeat: no-repeat;
          background-position: center center;
        }
        .tag_up {
          background-image: url("~@/assets/homepage_img/tag_up.png");
        }
        .tag_down {
          background-image: url("~@/assets/homepage_img/tag_down.png");
        }
        .tag_smooth {
          background-image: url("~@/assets/homepage_img/tag_smooth.png");
        }
        .gateitem {
          margin-top: 17px;
          width: 380px;
          // height: 100px;
          border: 1px solid #1a3a6c;
          .gatetop {
            height: 35px;
            line-height: 35px;
            background: #0f3164;
            .name {
              font-size: 15px;
              color: #fff;
              float: left;
              margin-left: 17px;
            }
            .time {
              color: #fff;
              font-size: 14px;
              float: right;
              margin-right: 10px;
            }
            .desc {
              font-size: 14px;
              color: #00deff;
              float: right;
              margin-right: 17px;
            }
          }
          .gateicons {
            margin-top: 6px;
            .gateicon {
              margin-left: 17px;
              height: 55px;
              position: relative;
              margin-top: 5px;
              // margin-bottom: 5px;
              text-align: center;
              width: 22px;
              height: 38px;
              img {
                width: 22px;
                height: 38px;
              }
              span {
                color: #fff;
                font-size: 14px;
                display: block;
              }
            }
          }
        }
      }
    }
  }
  .hyperlinks {
    width: 950px;
    height: 60px;
    position: absolute;
    top: 1000px;
    left: 480px;
    z-index: 9999;
    .hyperlinksList {
      width: 565px;
      height: 100%;
      margin: 0 auto;
      padding: 0;
      line-height: 50px;
      .hyperlinksItem {
        &:hover {
          background: #0590cf;
        }
        &:nth-of-type(4) {
          width: 155px;
        }
        list-style-type: none;
        width: 110px;
        height: 45px;
        padding: 5px 0;
        margin: 0 10px;
        border: 1px solid #0878b4;
        box-shadow: 0 0 5px #0878b4;
        line-height: 35px;
        border-radius: 30px;
        text-align: center;
        font-size: 18px;
        color: #ffffff;
        font-weight: 600;
        float: left;
        a {
          color: #ffffff;
        }
      }
      .hyperlinksItem_active {
        background: #0590cf;
      }
    }
  }
}
.meiyu /deep/ .el-dialog {
  z-index: 9999999;
  background-color: #060a22;
  margin-top: 22vh !important;
  width: 47%;
  // height: 50%
  .el-dialog__body {
    padding-top: 10px;
    overflow: auto;
    height: 400px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__close {
    color: #fff;
  }
}
.el-dialog {
  background-color: #060a22;
  .gateitem {
    margin-top: 17px;
    width: 100%;
    // height: 100px;
    border: 1px solid #1a3a6c;
    .gatetop {
      height: 35px;
      line-height: 35px;
      background: #0f3164;
      .name {
        font-size: 15px;
        color: #fff;
        float: left;
        margin-left: 17px;
      }
      .time {
        color: #fff;
        font-size: 14px;
        float: right;
        margin-right: 10px;
      }
      .desc {
        font-size: 14px;
        color: #00deff;
        float: right;
        margin-right: 17px;
      }
    }
    .gateicons {
      margin-top: 6px;
      .gateicon {
        margin-left: 17px;
        height: 55px;
        position: relative;
        margin-top: 5px;
        // margin-bottom: 5px;
        text-align: center;
        width: 22px;
        height: 38px;
        img {
          width: 22px;
          height: 38px;
        }
        span {
          color: #fff;
          font-size: 14px;
          display: block;
        }
      }
    }
  }
}
.meiyu /deep/ .el-table tr {
  // text-align: center;
  color: #fff;
  background: #060a22;
}
.meiyu /deep/ .el-table td {
  // text-align: center;
  padding: 5px 0;
  border: none;
}
.meiyu /deep/ #centermap .leaflet-control-container{
  .leaflet-bottom.leaflet-right{
    display: none;
  }
}
.meiyu /deep/ .el-table th.is-leaf {
  border: none;
}
.meiyu /deep/ .el-table th {
  // text-align: center;
  color: #00deff;
  background: #060a22;
}
.meiyu /deep/ .el-table .warning-red-row {
  background: #850b1a !important;
}
.meiyu /deep/ .el-table .warning-yellow-row {
  background: #856915 !important;
}

// .meiyu /deep/ .el-table .success-row {
//   background: #850b17;
// }
.meiyu /deep/ .el-table__body tr:hover > td {
  background: #072447;
}
.meiyu /deep/ .el-table::before {
  background: #060a22;
}
.meiyu /deep/ *::-webkit-scrollbar {
  width: 0.25rem;
  height: 0.25rem;
  background-color: #072351;
}
.meiyu /deep/ *::-webkit-scrollbar-track {
  border-radius: 0.1rem;
  background-color: #06214e;
}
.meiyu /deep/ *::-webkit-scrollbar-thumb {
  /*width: 0.1rem;
     */
  height: 0.2rem;
  border-radius: 0.1rem;
  background-color: #0c3974;
}
.meiyu /deep/ .el-table__header {
  table-layout: auto;
  border-collapse: separate;
}
.meiyu /deep/ .el-table__body-wrapper,
.meiyu /deep/ .is-scrolling-none,
// .meiyu /deep/ .is-scrolling-right {
//   height: 80% !important;
// }
// .meiyu /deep/ .el-table__body-wrapper,
// .meiyu /deep/ .is-scrolling-none,
// .meiyu /deep/ .el-table__body{
//   height: 222px!important;
// }
.el-table {
  background: #060a22;
}
</style>
